/** QuickPlan — Dialogue d'insertion d'un assemblage type : paramètres + position. */
import { useState } from 'react';
import { useProjectStore } from '../store/useProjectStore.js';
import { projectBounds } from '../geom.js';
import ParamField from './ParamField.jsx';

export default function TemplateDialog({ template }) {
  const close = useProjectStore((s) => s.closeDialog);
  const insertTemplate = useProjectStore((s) => s.insertTemplate);
  const [params, setParams] = useState(Object.fromEntries(template.params.map((p) => [p.key, p.default])));
  const [pos, setPos] = useState(() => {
    const st = useProjectStore.getState();
    const bb = projectBounds(st.project, st.lookup());
    return bb ? [Math.ceil((bb.max[0] + 200) / 10) * 10, 0, 0] : [0, 0, 0];
  });
  const [rotZ, setRotZ] = useState(0);

  const ok = () => {
    insertTemplate(template, params, pos, [0, 0, rotZ]);
    close();
  };

  return (
    <div className="modal-back" onMouseDown={close}>
      <div className="modal" onMouseDown={(e) => e.stopPropagation()} onKeyDown={(e) => { if (e.key === 'Enter') ok(); if (e.key === 'Escape') close(); }}>
        <h2>{template.name}</h2>
        {template.description && <p className="muted">{template.description}</p>}
        <div className="form-grid">
          {template.params.map((p) => (
            <ParamField key={p.key} param={p} value={params[p.key]} onChange={(v) => setParams({ ...params, [p.key]: v })} />
          ))}
        </div>
        <h3>Position de l'origine</h3>
        <div className="form-grid">
          {['X', 'Y', 'Z'].map((a, k) => (
            <label key={a}>{a} (mm)
              <input type="number" value={pos[k]} onChange={(e) => setPos(pos.map((v, j) => (j === k ? Number(e.target.value) || 0 : v)))} />
            </label>
          ))}
          <label>Rotation Z
            <select value={rotZ} onChange={(e) => setRotZ(Number(e.target.value))}>
              {[0, 90, 180, 270].map((d) => <option key={d} value={d}>{d}°</option>)}
            </select>
          </label>
        </div>
        <div className="modal-actions">
          <button onClick={close}>Annuler</button>
          <button className="primary" onClick={ok} autoFocus>Insérer</button>
        </div>
      </div>
    </div>
  );
}
